import { ContentResponse } from '../types/shared';
import { FC, ReactNode } from 'react';
import { Table } from '@kpa/kul';
import { TableblockResponse } from '../types/blocks';

type TabellBlockProps = {
  contentResponse: ContentResponse;
};

const FlikgruppBlock: FC<TabellBlockProps> = ({ contentResponse }): ReactNode => {
  const responseContent = contentResponse.content as TableblockResponse;

  return (
    <Table {...responseContent.table}></Table>
  );
};

export default FlikgruppBlock;
